import { render } from "./Imprint.vue?vue&type=template&id=ae16da94"
import script from "./Imprint.vue?vue&type=script&lang=js"
export * from "./Imprint.vue?vue&type=script&lang=js"

import "./Imprint.vue?vue&type=style&index=0&id=ae16da94&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__